import { render, staticRenderFns } from "./totalcost.vue?vue&type=template&id=00ce4784"
import script from "./totalcost.vue?vue&type=script&lang=js"
export * from "./totalcost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports